import { Box, Stack, Typography } from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import VnvAssistRecentRuns from "./components/VnvAssistRecentRuns";

const VnvAssistRecentsPage = () => (
  <Box sx={{ p: 3, maxWidth: 900, mx: "auto" }}>
    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
      <VerifiedIcon color="primary" />
      <Typography variant="h5" fontWeight={600}>
        Recent VNV Assist Runs
      </Typography>
    </Stack>
    <VnvAssistRecentRuns limit={50} showViewMore={false} />
  </Box>
);

export default VnvAssistRecentsPage;
